import { gql } from '@apollo/client';

export const TopicsBaseFragment = gql`
  fragment TopicsBaseFragment on Topic {
    topic
    themes {
      data {
        attributes {
          theme
        }
      }
    }
  }
`;
